export function square(x: number) {
  return x * x;
}

export function radToDeg(x: number) {
  return (x * 180) / Math.PI;
}
